import React from "react";

import {
  Image
} from '@lockerpm/design';

import images from "../../assets/images";

const AuthLogo = (props) => {
  const { AuthLogo } = images;
  const {
    className = 'mb-8',
    height = 48,
    width = 348,
  } = props;

  return (
    <div className={`flex items-center justify-center ${className}`}>
      <Image
        src={AuthLogo}
        preview={false}
        height={height}
        width={width}
      />
    </div>
  );
}

export default AuthLogo;